import { useEffect, useState } from "react";
import { cardBackUrl, cardFaceUrl, onCardImages, primeCardImages } from "./cardImages";

/**
 * The transitions' pack of this deck's card images, for a component that shows
 * a few of them (the home screen's hand, the table glimpse under a menu):
 * re-renders as images arrive, and makes sure the pack is being built.
 *
 * It renders nothing of its own. Building is normally already under way -
 * main.tsx starts it at launch - but reduced motion skips that because the
 * transitions then use no cards, so this asks too; on idle, so it never lands
 * in front of a first paint either way.
 */
export function useCardPack(): { back: string | null; face: (index: number) => string | null } {
  const [, bump] = useState(0);
  useEffect(() => {
    const off = onCardImages(() => bump((n) => n + 1));
    const ric = (globalThis as { requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => number })
      .requestIdleCallback;
    const start = () => primeCardImages();
    if (ric) ric(start, { timeout: 1500 });
    else window.setTimeout(start, 300);
    return off;
  }, []);
  return { back: cardBackUrl(), face: cardFaceUrl };
}
